import { render, staticRenderFns } from "./ThreeJSCanvasImage.vue?vue&type=template&id=2a317717&scoped=true"
import script from "./ThreeJSCanvasImage.vue?vue&type=script&lang=js"
export * from "./ThreeJSCanvasImage.vue?vue&type=script&lang=js"
import style0 from "./ThreeJSCanvasImage.vue?vue&type=style&index=0&id=2a317717&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a317717",
  null
  
)

export default component.exports